module.exports = __webpack_public_path__ + "static/media/expRed.a88c33b0.svg";